export const isSeoIndexingDisabled = (): boolean => {
  return process.env.DISABLE_META_INDEX === 'true';
};

export const getSeoMetaRobots = (index: boolean, follow: boolean) => {
  if (isSeoIndexingDisabled()) {
    return { robots: { index: false, follow: false }, other: { seoInternIndex: `${index}` } };
  }
  return { robots: { index, follow } };
};

export const getSeoMetaRobotsForCmsPage = (robots: string | undefined) => {
  if (isSeoIndexingDisabled()) {
    return { robots: { index: false, follow: false }, other: { seoInternIndex: robots || '' } };
  }
  return { robots: robots };
};

const getModelDetailText = (modelImagePerson: ModelImagePerson | undefined): string => {
  if (!modelImagePerson) return '';
  return `${modelImagePerson.name}${modelImagePerson.size ? ` (${modelImagePerson.size.value}${modelImagePerson.size.unit})` : ''}`;
};

const getModelPersonsWithDetailsText = (modelPersons: ModelImageBase['persons']): string => {
  if (!modelPersons) return '';
  return modelPersons
    .filter((p) => p.detail)
    .map((p) => getModelDetailText(p.detail))
    .join(' & ');
};

const hasModelPersonsWithDetails = (modelPersons: ModelImageBase['persons']): boolean => {
  return modelPersons ? modelPersons.some((p) => p.detail) : false;
};

export const getCompositionImageAltText = (
  compositionName: string,
  productTypeName: string,
  appearanceName: string,
  viewName?: string,
  modelPersons?: ModelImageBase['persons']
): string => {
  return `${compositionName} - ${productTypeName} - ${appearanceName}${viewName ? ` - ${viewName}` : ''}${hasModelPersonsWithDetails(modelPersons) ? ` - ${getModelPersonsWithDetailsText(modelPersons)}` : ''}`;
};

export const getProductTypeImageAltText = (
  productTypeName: string,
  appearanceName: string,
  viewName?: string,
  modelPersons?: ModelImageBase['persons']
): string => {
  return `${productTypeName} - ${appearanceName}${viewName ? ` - ${viewName}` : ''}${hasModelPersonsWithDetails(modelPersons) ? ` - ${getModelPersonsWithDetailsText(modelPersons)}` : ''}`;
};
